import { makeStyles } from "@material-ui/core/styles";

export const VendorFormJss = makeStyles((theme) => ({
  formGrid: {
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(7), 
    paddingRight: theme.spacing(4),
    paddingTop: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      paddingLeft: theme.spacing(4),
    },
  },
  formGridTitle: {
    padding: theme.spacing(4),
    paddingLeft: theme.spacing(7),
    color: '#000000',
    fontWeight: 900,
    fontSize: '1.25rem',
    [theme.breakpoints.down("sm")]: {
      paddingLeft: theme.spacing(4),
    },
  },
  formGridTitleTooltip: {
    paddingBottom: theme.spacing(4),
    paddingRight: theme.spacing(4),
    paddingTop: theme.spacing(6),
    color: '#000000',
    fontWeight: 900,
    fontSize: '1.25rem',
    display: "flex",
    gap: "5px"
  },
  textFieldInput: {
    backgroundColor: '#FFFFFF'
  },
}));
